// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"adb0da96","739":"0bd5a423","848":"add08fb6"}[chunkId] + ".js";
};